import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = { class: "d-flex justify-content-between bd-highlight mb-3" }
const _hoisted_3 = {
  class: "align-self-center mb-3",
  style: {"height":"30px"}
}
const _hoisted_4 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "序号"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "标题"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ID"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "状态"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "添加时间"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "操作")
  ])
], -1)
const _hoisted_6 = { id: "member-list" }
const _hoisted_7 = {
  class: "mb-1 form-check form-switch",
  style: {"padding-top":"5px"}
}
const _hoisted_8 = {
  key: 0,
  class: "form-check-input",
  checked: "",
  type: "checkbox",
  role: "switch"
}
const _hoisted_9 = {
  key: 1,
  class: "form-check-input",
  type: "checkbox",
  role: "switch"
}
const _hoisted_10 = { class: "flex-row flex-align-center" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_AddArticleLabelDialog = _resolveComponent("AddArticleLabelDialog")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openAddLabelDialog && $setup.openAddLabelDialog(...args)))
          }, "添加")
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataList, (value, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(50 * ($setup.nowPage - 1) + idx + 1), 1),
                _createElementVNode("td", null, _toDisplayString(value.title), 1),
                _createElementVNode("td", null, _toDisplayString(value.id), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_7, [
                    (value.show === 1)
                      ? (_openBlock(), _createElementBlock("input", _hoisted_8))
                      : (_openBlock(), _createElementBlock("input", _hoisted_9))
                  ])
                ]),
                _createElementVNode("td", null, _toDisplayString($setup.dateFtt('yyyy-MM-dd hh:mm', new Date(value.operateTime))), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", {
                      class: "button-icon",
                      src: "/assets/ic_edit.png",
                      onClick: ($event: any) => ($setup.openEditLabelDialog(value.id))
                    }, null, 8, _hoisted_11),
                    _createElementVNode("img", {
                      class: "button-icon img-margin",
                      src: "/assets/ic_trash.png",
                      onClick: ($event: any) => ($setup.deleteLabel(value.id, value.title))
                    }, null, 8, _hoisted_12)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_Pagination, {
          page: $setup.nowPage,
          max: $setup.totalPage/50,
          onLoadPage: $setup.loadChankangLabelList
        }, null, 8, ["page", "max", "onLoadPage"])
      ])
    ]),
    _createVNode(_component_AddArticleLabelDialog, {
      show: _ctx.showAddDialog,
      hasRecommend: false,
      label: _ctx.editLabel,
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddDialog = false)),
      onConfirm: $setup.editChankangLabel
    }, null, 8, ["show", "label", "onConfirm"]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}